/**
 * Fabricate on a type: busy while its own stream runs, disabled while another type's does, and at the
 * cap disabled with the reason on hover.
 */

import { Loader2, Sparkles } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { PillButton } from '@/modules/simulator/ui/pill-button';
import { FABRICATED_PER_TYPE_MAX } from '../scenario-counts';

interface FabricateButtonProps {
	atCap: boolean;
	busy: boolean;
	disabled?: boolean;
	onClick: () => void;
}

export const FabricateButton = ({ atCap, busy, disabled = false, onClick }: FabricateButtonProps) => {
	const button = (
		<PillButton disabled={atCap || busy || disabled} onClick={onClick}>
			{busy ? <Loader2 className='size-3 animate-spin' /> : <Sparkles className='size-3' />}
			{busy ? 'Fabricating…' : 'Fabricate'}
		</PillButton>
	);
	if (!atCap) return button;
	// A disabled button fires no pointer events, so the span carries the hover.
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span className='inline-flex'>{button}</span>
			</TooltipTrigger>
			<TooltipContent className='max-w-xs'>
				This scenario type holds {FABRICATED_PER_TYPE_MAX} fabricated scenarios, the most it can. Delete some to make room.
			</TooltipContent>
		</Tooltip>
	);
};
